import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardTitle,
  CardBody,
  Row,
  Col,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  FormGroup,
  Label,
} from "reactstrap";
import { URL } from "../../api";
import axiosInstance from "../../Request";

const PanCredit = ({ cid, pan_validation_data }) => {
  const [panModal, setPanModal] = useState(false);
  const [commentModal, setCommentModal] = useState(false);
  const [panData, setPanData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showFetchButton, setShowFetchButton] = useState(false);
  const [comment, setComment] = useState("");
  const [panStatus, setPanStatus] = useState("Pending");

  const userId = localStorage.getItem("user_id");

  useEffect(() => {
    setPanStatus(pan_validation_data ? "Done" : "Pending");
  }, [pan_validation_data]);

  const togglePanModal = async () => {
    const opening = !panModal;
    setPanModal(opening);
    setErrorMessage("");

    if (opening && cid) {
      await fetchPanData(cid);
    }
  };

  const fetchPanData = async (customerId) => {
  const response = await axiosInstance.get(`${URL.PAN_DETAILS}?customer_id=${customerId}`);
  const data = response.data;

  if (!response.status === 200 || (data && data.message)) {
    setErrorMessage(data.message || "Something went wrong");
    setPanData(null);
    setPanStatus("Pending");
    return;
  }
    const allFieldsNull = Object.values(data).every(
      (val) => val === null || val === "" || val === undefined
    );

    if (data.panNumber && !data.name && !data.dob) {
      setShowFetchButton(true);
      setPanStatus("Pending");
    } else if (allFieldsNull) {
      setPanData(null);
      setErrorMessage("No valid PAN data available");
      setPanStatus("Pending");
    } else {
      setPanData(data);
      setPanStatus("Done");
    }
  };

  const handleFetchClick = () => {
    setCommentModal(true);
  };

  const handleSubmitComment = async () => {
    if (!cid || !userId || !comment.trim()) {
      alert("Customer ID, User ID, and Comment are required");
      return;
    }

    setLoading(true);
    setCommentModal(false);
    setErrorMessage("");

    try {
  const response = await axiosInstance.get(
    `${URL.PAN_VALIDATE_THIRD_PARTY}?customer_id=${cid}&user_id=${userId}&comment=${encodeURIComponent(comment)}`
  );

  if (response.status === 200) {
    alert("PAN details fetched from third-party API.");
    await fetchPanData(cid);
  } else {
    const data = response.data;
    const err = data.message || data.error || "Third-party fetch failed.";
    setErrorMessage(err);
    setPanStatus("Pending");
  }
} catch (err) {
  console.error("Third-party error:", err);
  setErrorMessage("Failed to reach third-party service");
  setPanStatus("Pending");
}

setLoading(false);
  };

  return (
    <>
      <Col xs="6" sm="4" md="3">
        <Card className="card-stats mb-4">
          <CardBody>
            <Row>
              <div className="col">
                <CardTitle tag="h5" className="text-uppercase text-muted mb-0">
                  PAN Validation
                </CardTitle>
                <span
                  className={`h2 font-weight-bold mb-0 clickable ${
                    panStatus === "Done" ? "text-success" : "text-danger"
                  }`}
                  onClick={togglePanModal}
                  style={{ cursor: "pointer" }}
                >
                  {loading ? "Loading..." : panStatus}
                </span>
              </div>
            </Row>
          </CardBody>
        </Card>
      </Col>

      {/* PAN Modal */}
      <Modal isOpen={panModal} toggle={togglePanModal} size="lg">
        <ModalHeader toggle={togglePanModal}>PAN Verification</ModalHeader>
        <ModalBody>
          {loading ? (
            <span>Loading...</span>
          ) : panData && panData.message ? (
            <div className="bg-light p-2 rounded">{panData.message}</div>
          ) : errorMessage ? (
            <div className="bg-danger text-white p-2 rounded">{errorMessage}</div>
          ) : panData ? (
            <Table className="align-items-center table-flush" responsive>
              <thead className="thead-light">
                <tr>
                  <th>Name</th>
                  <th>PAN</th>
                  <th>DOB</th>
                  <th>Match %</th>
                  <th>Status</th>
                  <th>Aadhaar Number</th>
                  <th>Aadhaar Link</th>
                  <th>Email</th>
                  <th>Error Reason</th>
                  <th>Gender</th>
                  <th>Mobile</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{panData.name || "N/A"}</td>
                  <td>{panData.panNumber || "N/A"}</td>
                  <td>{panData.dob || "N/A"}</td>
                  <td>{panData.nameMatchScore || "N/A"}</td>
                  <td>{panData.status || "N/A"}</td>
                  <td>{panData.aadhaar || "N/A"}</td>
                  <td>{panData.aadhaarLink || "N/A"}</td>
                  <td>{panData.emailId || "N/A"}</td>
                  <td>{panData.errorReason || "N/A"}</td>
                  <td>{panData.gender || "N/A"}</td>
                  <td>{panData.phoneNumber || "N/A"}</td>
                </tr>
              </tbody>
            </Table>
          ) : showFetchButton ? (
            <Button color="primary" onClick={handleFetchClick}>
              Fetch PAN Details
            </Button>
          ) : (
            <span>No data available</span>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={togglePanModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

      {/* Comment Modal */}
      <Modal isOpen={commentModal} toggle={() => setCommentModal(false)}>
        <ModalHeader toggle={() => setCommentModal(false)}>
          Enter Comment to Fetch PAN Details
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="comment">Comment</Label>
            <Input
              id="comment"
              type="textarea"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Enter comment"
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={handleSubmitComment}>
            Submit
          </Button>
          <Button color="secondary" onClick={() => setCommentModal(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default PanCredit;
